import React, { createContext, useEffect, useMemo, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = props => {
  const [userRequest, setUserRequest] = useState({
    loading: true,
    user: null,
  });

  useEffect(() => {
    asyncUserInfo();
  }, []);

  const asyncUserInfo = async () => {
    setUserRequest(prev => ({ ...prev, loading: true }));
    const token = localStorage.getItem('token');

    if (!token) {
      setUserRequest(prev => ({ ...prev, loading: false }));
      return false;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/auth/me`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 403 || response.status === 401) {
        localStorage.clear();
        window.location.href = '/#/login';
        return Promise.reject('Forbidden');
      }

      if (!response.ok) {
        throw new Error('Failed to fetch user info');
      }

      const data = await response.json();
      setUserRequest({ loading: false, user: data });
      return data;
    } catch (error) {
      console.error(error);
      setUserRequest({ user: null, loading: false });
      return null;
    }
  };

  const getTeam = () => userRequest.user?.team?.id || null;
  const getId = () => userRequest.user?.id || null;
  const getUserData = () => {
    return {
      username: userRequest.user?.username,
      email: userRequest.user?.email,
      avatar: userRequest.user?.avatar,
      roles: userRequest.user?.roles,
      points: userRequest.user?.points,
    };
  };
  const getTotalMembers = () => userRequest.user?.team?.members?.length || 0;
  const getTeamName = () => userRequest.user?.team?.name || null;
  const contextValues = useMemo(() => {
    return {
      userRequest,
      loading: userRequest.loading,
      asyncUserInfo,
      team: getTeam(),
      userId: getId(),
      userData: getUserData(),
      totalMembers: getTotalMembers(),
      teamName: getTeamName(),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRequest]);

  return <UserContext.Provider value={contextValues} {...props} />;
};

export function useUser() {
  const context = React.useContext(UserContext);
  if (!context) {
    throw new Error('UserContext debe estar dentro del UserProvider');
  }
  return context;
}
